/*@flow*/
import * as I from 'immutable';

export default (reducer: Object): Function => {
  const initState = I.Map();
  return (inputState = initState, action: Object): I.Map<*, *> => {
    return inputState.withMutations(temporaryState => {
      const currentDomainState = temporaryState;
      const nextDomainState = reducer(currentDomainState, action);
      temporaryState.merge(nextDomainState);
    });
  };
};
